<template>
    <el-dialog class="orderDialog" title="导入处方" :visible.sync="dialogFormVisible" :append-to-body='true'>
        <el-radio-group v-model="isHis">
            <el-radio-button :label="false">&nbsp;&nbsp;&nbsp;我的常用方&nbsp;&nbsp;&nbsp;</el-radio-button>
            <el-radio-button :label="true">{{patientInfo.compatName}}的历史处方</el-radio-button>
        </el-radio-group>

        <!--我的常用方-->
        <div v-if="!isHis" class="flex">
            <div class="flex column mr20 br pr20 mt30">
                <div class="flex0 mb10">
                    <el-autocomplete
                            size="mini"
                            v-model="key"
                            placeholder="输入名称或首字母"
                            :fetch-suggestions="fetchDiagnosis"
                            @keyup.enter.native="searchDocUsedList(key)"
                            @select="(item)=>{selectDiagnose(item)}"
                    ></el-autocomplete>
                    <el-button size="mini" type="primary" id="search-btn"
                               @click="searchDocUsedList(key)">搜索
                    </el-button>
                </div>
                <ul class="orderList flex1 color333 fs14">
                    <li v-if="docUsedList.length>0"
                        v-for="(item ,index) in docUsedList" :key="index"
                        :class="orderId===item.id?'bg_main color_fff':''"
                        class="flex space-between pt5 pb5 pl5 pr5"
                        @click="getUsedDetail(item)">
                        <span class="orderList__left ellipsis">{{item.usedName}}</span>
                        <span class="color666">{{item.usedCode}}</span>
                    </li>
                    <li v-if="docUsedList.length===0 && !firstClick" class="mt30">暂未搜索到相关常用方</li>
                </ul>
            </div>
            <el-table v-if="orderType==='CHINESE_RECIPE'" :data="orderDetail"
                      border show-header style="width: 100%" class="orderDetail" >
                <el-table-column align="center" type="index"></el-table-column>
                <el-table-column prop="drugName" label="药品名称" align="center"></el-table-column>
                <el-table-column prop="dosage" label="单次剂量" align="center"></el-table-column>
                <el-table-column prop="dosageUnit" label="单位" align="center"></el-table-column>
<!--                <el-table-column prop="drugUnitPrice" label="单价" align="center">-->
<!--                    <template slot-scope="scope" v-if="scope.row.drugUnitPrice">-->
<!--                        <span>{{scope.row.drugUnitPrice? scope.row.drugUnitPrice/100: ''}}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="docName" label="金额" align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span>{{scope.row.dosage? scope.row.drugUnitPrice/100*scope.row.dosage : ''}}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="drugOrigin" label="产地" align="center"></el-table-column>-->
                <el-table-column prop="admission" label="用法" align="center"></el-table-column>
            </el-table>

            <el-table :data="orderDetail" border style="width: 100%" class="orderDetail" v-else>
                <el-table-column align="center" type="index"></el-table-column>
                <el-table-column prop="drugName" label="药品名称"></el-table-column>
                <el-table-column prop="dosage" label="单次剂量" min-width="70"></el-table-column>
                <el-table-column prop="dosageUnit" label="剂量单位" min-width="70"></el-table-column>
                <el-table-column prop="admission" label="用法" min-width="100"></el-table-column>
                <el-table-column prop="frequencyName" label="频次" min-width="100">
                </el-table-column>
                <el-table-column prop="useDays" label="天数" min-width="70">
                </el-table-column>
                <el-table-column prop="amount" label="总量" min-width="70">
                </el-table-column>
                <el-table-column prop="dosageUnit" label="单位"></el-table-column>
<!--                <el-table-column prop="drugUnitPrice" label="单价" min-width="70">-->
<!--                    <template slot-scope="scope" v-if="scope.row.drugUnitPrice">-->
<!--                        <span>{{scope.row.drugUnitPrice? scope.row.drugUnitPrice/100: ''}}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
            </el-table>
        </div>
        <!--患者历史处方-->

        <el-table v-else :data="hisList"
                  border show-header style="width: 100%">
            <el-table-column prop="orderNo" label="处方编号" align="center"></el-table-column>
            <el-table-column prop="createDate" label="开方时间" :formatter="formatTime" align="center"></el-table-column>
            <el-table-column prop="docName" label="开方医生" align="center"></el-table-column>
            <el-table-column prop="drugNameStr" align="center" :show-overflow-tooltip='true'
                             :label="orderType==='CHINESE_RECIPE'?'药材':'药品'">
                <template slot-scope="scope">{{scope.row.drugNameStr}}</template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <p class="color_main" @click="replaceCurrent(scope.row)" style="cursor:pointer">导入处方</p>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="!isHis" class="right pt15">
            <el-button type="primary" size="medium" @click="replaceCurrent('used')">导入处方</el-button>
        </el-row>
        <!--分页-->
        <el-row v-else class="pagination-wrapper" type="flex" justify="center aic jcc">
            <span class="pr20">共{{page.total}}条</span>
            <el-pagination
                    layout="prev, pager, next"
                    :current-page.sync="page.pageNum"
                    :page-size="5"
                    :total="page.total"
                    @current-change="onCurrentChange"
            ></el-pagination>
        </el-row>
    </el-dialog>
</template>

<script>
  import {timeFormat, sex} from "ty-vue-filters";
  import {tokenCache} from "../../lib/cache/Token";

  export default {
    name: "history-rp-dialog",
    props: {
      hisList: Array,
      page: Object,
      patientInfo: Object,
      drugList: Array,
      orderType: String
    },
    data() {
      return {
        dialogFormVisible: false,
        firstClick: true,
        isHis: false,//选择处方类型 his-历史处方 used-常用处方
        key: '',
        orderDetail: [],
        docUsedList: [],
        orderId: '',
      }
    },
    filters: {
      sex,
      timeFormat
    },
    methods: {
      async getUsedDetail(item) {
        this.orderId = item.id
        this.orderDetail = item.usedOrderInfoList
        /*  let {code, obj} = await this.$http("smarthos.recipe.usedorder.info", {id: item.id})
          if (code == '0') {
              console.log(33434, obj)
              this.orderDetail = obj.RecipeUsedOrderInfoVO
          }*/
      },
      async fetchDiagnosis(queryString, cb = () => {
      }) {
        let {code, list} = await this.$http("smarthos.recipe.usedorder.list.page", {
          usedName: queryString,
          usedType: this.orderType === 'CHINESE_RECIPE' ? 'CHINESE_USED' : 'WESTERN_USED',
          token: tokenCache.get(),
        })
        if (code == '0') {
          for (let i of list) {
            i.value = i.usedName; //必须绑定value值作为显示数据
          }
          cb(list);
        }
      },
      //搜索
      async searchDocUsedList(key) {
        let {code, list} = await this.$http("smarthos.recipe.usedorder.list.page", {
          usedName: key,
          usedType: this.orderType === 'CHINESE_RECIPE' ? 'CHINESE_USED' : 'WESTERN_USED',
          token: tokenCache.get(),
        })
        if (code == '0') {
          this.firstClick = false
          this.docUsedList = list
        }
      },
      selectDiagnose(item) {
        this.orderId = item.id
        this.docUsedList = [item]
        this.orderDetail = item.usedOrderInfoList
      },
      show() {
        this.dialogFormVisible = true;
        this.searchDocUsedList('')
      },
      close() {
        this.dialogFormVisible = false;
        this.orderDetail = []
        this.docUsedList = []
      },
      formatTime(row, column, time) {
        return timeFormat(time, "%Y/%m/%d");
      },
      onCurrentChange(pageNum) {
          console.log('【翻页】', pageNum)
        this.$emit('changePage', pageNum)

      },
      replaceCurrent(val) {
        let check = this.drugList.filter((item) => {
          return item.drugName
        })
        if (check.length > 0) {
          this.$confirm('导入处方后会覆盖掉您当前处方内已存在的药材确定导入吗？', '导入处方提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {
            this.sendDrugList(val)
          })
        } else {
          this.sendDrugList(val)
        }
      },
      sendDrugList(val) {
        let drugs = []
        if (val.drugList) {
          val.drugList.forEach((item) => {
            item.price = item.drugUnitPrice
            item.frequencyObj = item.frequencyCode + '/' + item.frequencyName
          })
          drugs = val.drugList
        } else {
          this.orderDetail.forEach((item) => {
            item.price = item.drugUnitPrice
            item.frequencyObj = item.frequencyCode + '/' + item.frequencyName
          })
          drugs = this.orderDetail
        }
        this.close()
        this.$emit('replaceCurrent', drugs)
      }
    },
    watch: {
      isHis: {
        handler(newV) {
          if (newV) {
            this.onCurrentChange(1)
          }
        }
      },
      hisList(newV) {
          // console.log('【历史处方发生变化】',newV)
      }
    }
  }
</script>
<style lang="scss" scoped>
    .orderList {
        height: 200px;
        width: 233px;
        overflow: auto;
        &__left {
            width: 70%;
            text-align: left;
        }
    }

    .orderDetail {
        height: 350px;
        width: 233px;
        overflow: auto;
    }


</style>
